<template>
    <main class="flex min-h-[100dvh] w-full items-center justify-center bg-app-bg p-[24px] text-fg dark:bg-app-bg-dark dark:text-fg-dark" data-minimum-viewport>
        <div class="flex w-full min-w-0 flex-col items-center gap-[12px] text-center">
            <span class="flex size-[48px] shrink-0 items-center justify-center rounded-full bg-surface-3 text-fg-muted dark:bg-surface-3-dark dark:text-fg-muted-dark" aria-hidden="true">
                <IdeoIcon name="monitor" :size="24" />
            </span>
            <h1 class="m-0 text-[1.125rem]/[1.35] font-[600]">
                {{ $t('[[[Ekran jest zbyt wąski]]]') }}
            </h1>
            <p class="m-0 text-ui-body/[1.6] text-fg-muted dark:text-fg-muted-dark">
                {{ $t('[[[Panel administracyjny wymaga szerokości co najmniej 360 pikseli. Poszerz okno przeglądarki lub użyj urządzenia z szerszym ekranem.]]]') }}
            </p>
        </div>
    </main>
</template>
